import { pli } from "./pli";
import pliCall, { PliCallSettings, PliCallPromise } from "./call";

declare module "./pli" {
    /**
     * Extend base Pli singleton with call-specific API. Do not use. Import call from "pli/core/call" instead.
     */
    interface PliSingleton {
        /**
         * Do not use. Import call from "pli/core/call" instead.
         */
        call<TRequestData, TOwner, TResponseData>(settings: PliCallSettings<TRequestData, TOwner>): PliCallPromise<TResponseData, TOwner>;
    }
}

pli.call = pliCall;

if (pli.config.isBrowser) {
    (global as any).Pli = pli;
}

export = pli;



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/core/index.ts